import { Stack, styled } from '@mui/material';

import { scrollbarStyles, theme } from '@/design-system';

export const Root = styled('div')({
  position: 'relative',
  width: '100%',
});

export const FieldWrap = styled('div')({
  position: 'relative',
  width: '100%',
});

export const Control = styled('div', {
  shouldForwardProp: (prop) => prop !== '$focused' && prop !== '$disabled',
})<{ $focused?: boolean; $disabled?: boolean }>(({ $focused, $disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  boxSizing: 'border-box',
  padding: '0 12px',
  height: '44px',
  borderRadius: theme.radius[8],
  background: theme.colors.background.overlay,
  border: `1px solid ${$focused ? theme.colors.border.focus : theme.colors.white[20]}`,
  boxShadow: theme.shadows.xs,
  cursor: $disabled ? 'default' : 'text',
  opacity: $disabled ? 0.6 : 1,
  transition: 'border-color 0.15s ease',
}));

export const SearchIconWrapper = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: theme.colors.icon.tertiary,
});

export const Input = styled('input')({
  flex: 1,
  minWidth: 0,
  border: 0,
  outline: 'none',
  background: 'transparent',
  color: theme.colors.text.primary,
  fontFamily: 'inherit',
  fontSize: '14px',
  lineHeight: 1.4,
  padding: 0,
  '::placeholder': {
    color: theme.colors.text.tertiary,
  },
  ':disabled': {
    cursor: 'default',
  },
});

export const Popup = styled('div')({
  position: 'absolute',
  top: 'calc(100% + 6px)',
  left: 0,
  right: 0,
  zIndex: 10,
  maxHeight: '260px',
  overflowY: 'auto',
  padding: '6px',
  borderRadius: '12px',
  background: theme.colors.background.raised,
  border: `1px solid ${theme.colors.border.default}`,
  boxShadow: theme.shadows.lg,
  ...scrollbarStyles,
});

export const OptionRow = styled('button', {
  shouldForwardProp: (prop) => prop !== '$selected',
})<{ $selected?: boolean }>(({ $selected }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  width: '100%',
  textAlign: 'left',
  border: 0,
  background: $selected ? theme.colors.white[8] : 'transparent',
  cursor: 'pointer',
  padding: '8px 10px',
  borderRadius: '8px',
  font: 'inherit',
  ':hover': {
    background: theme.colors.white[8],
  },
}));

export const OptionText = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
  minWidth: 0,
  flex: 1,
});

export const StateRow = styled(Stack)({
  alignItems: 'center',
  gap: '10px',
  padding: '16px 12px',
});

export const ChipsRow = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  marginTop: '8px',
});

export const ChipTag = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  maxWidth: '100%',
  padding: '4px 6px 4px 10px',
  borderRadius: '8px',
  background: theme.colors.white[8],
  color: theme.colors.text.primary,
  fontSize: '13px',
  lineHeight: 1.3,
});

export const ChipRemove = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '16px',
  height: '16px',
  flexShrink: 0,
  border: 0,
  padding: 0,
  borderRadius: '4px',
  background: 'transparent',
  cursor: 'pointer',
  color: theme.colors.icon.tertiary,
  ':hover': {
    color: theme.colors.icon.primary,
  },
});
